import { ReactNode } from 'react';

import { styled, SxProps, Theme } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

interface Props {
  children: ReactNode;
  isMobileWide?: boolean;
  sx?: SxProps<Theme>;
}

const ActionsWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['isMobileWide'].includes(prop as string),
})<{ isMobileWide?: boolean }>(({ theme: { spacing, breakpoints }, isMobileWide }) => ({
  display: 'flex',
  gap: spacing(2),
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  ...(isMobileWide && {
    alignItems: 'stretch',
    flexDirection: 'column-reverse',
    [breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
      justifyContent: 'flex-start',
    },
  }),
}));

export default function ActionsContainer({ children, isMobileWide, sx, ...otherProps }: Props) {
  return (
    <ActionsWrapper isMobileWide={isMobileWide} {...otherProps} {...sx}>
      {children}
    </ActionsWrapper>
  );
}
